import ChatSendMessage from './styled';

export default ChatSendMessage;
